// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { Footer } from "../components";
// import { useNavigate } from "react-router-dom";
// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();

//   let Submit = (e) => {
//     e.preventDefault();
//     const newEntry = {
//       email: email,
//       password: password,
//     };
//     console.log([newEntry]);
//     if (email === "" || password === "")
//       return window.alert("Please Fill out the field first");
//     else {

//       const url = "https://yb-ecommerce-backend.onrender.com/api/login";
//       const params = {
//         method: "post",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(newEntry),
//       };
//       fetch(url, params)
//         .then((res) => {
//           return res.json();
//         })
//         .then((data) => {
//           console.log(data);
//           if (data.message !== "Login successful") return;
//           navigate("/Navbar2");
//         });
//     }
//   };
//   return (
//     <>
    
//       <div className="container my-3 py-3">
//         <h1 className="text-center">Login</h1>
//         <hr />
//         <div className="row my-4 h-100">
//           <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
//             <form onSubmit={Submit}>
//               <div className="my-3">
//                 <label htmlFor="display-4">Email address</label>
//                 <input value={email} onChange={(e) => setEmail(e.target.value)}type="email" placeholder="Enter your email id"/>
//               </div>
//               <div className="my-3">
//                 <label htmlFor="floatingPassword display-4">Password</label>
//                 <input value={password} onChange={(e) => setPassword(e.target.value)}type="password" placeholder="********"/>
//               </div>
//               <div className="my-3">
//                 <p>New Here? <Link to="/register" className="text-decoration-underline text-info">Register</Link> </p>
//               </div>
//               <div className="text-center">
                
//                 <button className="my-2 mx-auto btn btn-dark">
//                   Login
//                 </button>
              
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default Login;











// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { Footer, Navbar } from "../components";


// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();

//   let Submit = (e) => {
//     e.preventDefault();
//     const newEntry = {
//       email: email,
//       password: password,
//     };
//     console.log([newEntry]);
//     if (email === "" || password === "")
//       return window.alert("Please Fill out the field first");
//     else {
//       //  const backendUrl = process.env.REACT_APP_BACKEND_URL;
//       // const url = `${backendUrl}/api/login`;
//       const url = "https://yb-ecommerce-backend.onrender.com/api/login";
//       const params = {
//         method: "post",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(newEntry),
//       };
//       fetch(url, params)
//         .then((res) => {
//           return res.json();
//         })
//         .then((data) => {
//           console.log(data);
//           if (data.message !== "Login successful") return;
//           navigate("/Navbar2");
//         });
//     }
//   };
//   return (
//     <>
//       <Navbar />
//       <div className="container my-3 py-3">
//         <h1 className="text-center">Login</h1>
//         <hr />
//         <div class="row my-4 h-100">
//           <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
//             <form>
//               <div class="my-3">
//                 <label for="display-4">Email address</label>
//                 <input
//                   type="email"
//                   class="form-control"
//                   id="floatingInput"
//                   placeholder="name@example.com"
//                 />
//               </div>
//               <div class="my-3">
//                 <label for="floatingPassword display-4">Password</label>
//                 <input
//                   type="password"
//                   class="form-control"
//                   id="floatingPassword"
//                   placeholder="Password"
//                 />
//               </div>
//               <div className="my-3">
//                 <p>New Here? <Link to="/register" className="text-decoration-underline text-info">Register</Link> </p>
//               </div>
//               <div className="text-center">
//                 <button class="my-2 mx-auto btn btn-dark" type="submit" disabled>
//                   Login
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default Login;



// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { Footer, Navbar } from "../components";

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const newEntry = { email, password };
//     console.log([newEntry]);

//     if (email === "" || password === "")
//       return window.alert("Please fill out the fields first");

//     const url = "https://yb-restaurant-backend.onrender.com/api/login";
//     const params = {
//       method: "post",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(newEntry),
//     };

//     fetch(url, params)
//       .then((res) => res.json())
//       .then((data) => {
//         console.log(data);
//         if (data.message !== "Login successful") return;
//         navigate("/products");
//       });
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="container my-3 py-3">
//         <h1 className="text-center">Login</h1>
//         <hr />
//         <div className="row my-4 h-100">
//           <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
//             <form onSubmit={handleSubmit}>
//               <div className="my-3">
//                 <label htmlFor="email">Email address</label>
//                 <input
//                   type="email"
//                   className="form-control"
//                   id="email"
//                   placeholder="name@example.com"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                 />
//               </div>
//               <div className="my-3">
//                 <label htmlFor="password">Password</label>
//                 <input
//                   type="password"
//                   className="form-control"
//                   id="password"
//                   placeholder="Password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                 />
//               </div>
//               <div className="my-3">
//                 <p>
//                   New Here?{" "}
//                   <Link to="/register" className="text-decoration-underline text-info">
//                     Register
//                   </Link>
//                 </p>
//               </div>
//               <div className="text-center">
//                 <button className="my-2 mx-auto btn btn-dark" type="submit">
//                   Login
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default Login;





// import React, { useState, useContext } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { Footer, Navbar } from "../components";
// import { AuthContext } from "../context/AuthContext";

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();
//   const { login } = useContext(AuthContext);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const newEntry = { email, password };

//     if (email === "" || password === "") {
//       return window.alert("Please fill out the fields first");
//     }

//     const url = "https://yb-ecommerce-backend.onrender.com/api/login"; // Correct endpoint
//     const params = {
//       method: "post",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(newEntry),
//     };

//     fetch(url, params)
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.message !== "Login successful") return window.alert(data.message);
//         login();
//         navigate("/products");
//       })
//       .catch((error) => {
//         console.error("Error during login:", error);
//         window.alert("An error occurred during login. Please try again.");
//       });
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="container my-3 py-3">
//         <h1 className="text-center">Login</h1>
//         <hr />
//         <div className="row my-4 h-100">
//           <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
//             <form onSubmit={handleSubmit}>
//               <div className="my-3">
//                 <label htmlFor="email">Email address</label>
//                 <input
//                   type="email"
//                   className="form-control"
//                   id="email"
//                   placeholder="name@example.com"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                 />
//               </div>
//               <div className="my-3">
//                 <label htmlFor="password">Password</label>
//                 <input
//                   type="password"
//                   className="form-control"
//                   id="password"
//                   placeholder="Password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                 />
//               </div>
//               <div className="my-3">
//                 <p>
//                   New Here?{" "}
//                   <Link to="/register" className="text-decoration-underline text-info">
//                     Register
//                   </Link>
//                 </p>
//               </div>
//               <div className="text-center">
//                 <button className="my-2 mx-auto btn btn-dark" type="submit">
//                   Login
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default Login;



// import React, { useState, useContext } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { Footer, Navbar } from "../components";
// import { AuthContext } from "../context/AuthContext";

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();
//   const { login, logout, isAuthenticated } = useContext(AuthContext);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const newEntry = { email, password };

//     if (email === "" || password === "") {
//       return window.alert("Please fill out the fields first");
//     }

//     const url = "https://yb-restaurant-backend.onrender.com/api/login"; // Correct endpoint
//     const params = {
//       method: "post",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(newEntry),
//     };

//     fetch(url, params)
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.message !== "Login successful") return window.alert(data.message);
//         login();
//         navigate("/products");
//       })
//       .catch((error) => {
//         console.error("Error during login:", error);
//         window.alert("An error occurred during login. Please try again.");
//       });
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="container my-3 py-3">
//         <h1 className="text-center">Login</h1>
//         <hr />
//         <div className="row my-4 h-100">
//           <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
//             {isAuthenticated ? (
//               <div className="text-center">
//                 <button className="my-2 mx-auto btn btn-dark" onClick={logout}>
//                   Logout
//                 </button>
//               </div>
//             ) : (
//               <form onSubmit={handleSubmit}>
//                 <div className="my-3">
//                   <label htmlFor="email">Email address</label>
//                   <input
//                     type="email"
//                     className="form-control"
//                     id="email"
//                     placeholder="name@example.com"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                   />
//                 </div>
//                 <div className="my-3">
//                   <label htmlFor="password">Password</label>
//                   <input
//                     type="password"
//                     className="form-control"
//                     id="password"
//                     placeholder="Password"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                   />
//                 </div>
//                 <div className="my-3">
//                   <p>
//                     New Here?{" "}
//                     <Link to="/register" className="text-decoration-underline text-info">
//                       Register
//                     </Link>
//                   </p>
//                 </div>
//                 <div className="text-center">
//                   <button className="my-2 mx-auto btn btn-dark" type="submit">
//                     Login
//                   </button>
//                 </div>
//               </form>
//             )}
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default Login;


// import React, { useState, useContext } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { AuthContext } from "../context/AuthContext";

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();
//   const { login, logout, isAuthenticated } = useContext(AuthContext);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const newEntry = { email, password };

//     if (email === "" || password === "") {
//       return window.alert("Please fill out the fields first");
//     }

//     const url = "https://yb-restaurant-backend.onrender.com/api/login";
//     const params = {
//       method: "post",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(newEntry),
//     };

//     fetch(url, params)
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.message !== "Login successful") return window.alert(data.message);
//         login();
//         navigate("/products");
//       })
//       .catch((error) => {
//         console.error("Error during login:", error);
//         window.alert("An error occurred during login. Please try again.");
//       });
//   };

//   return (
//     <div className="container my-3 py-3">
//       <h1 className="text-center">Login</h1>
//       <hr />
//       <div className="row my-4 h-100">
//         <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
//           {isAuthenticated ? (
//             <div className="text-center">
//               <button className="my-2 mx-auto btn btn-dark" onClick={logout}>
//                 Logout
//               </button>
//             </div>
//           ) : (
//             <form onSubmit={handleSubmit}>
//               <div className="my-3">
//                 <label htmlFor="email">Email address</label>
//                 <input
//                   type="email"
//                   className="form-control"
//                   id="email"
//                   placeholder="name@example.com"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                 />
//               </div>
//               <div className="my-3">
//                 <label htmlFor="password">Password</label>
//                 <input
//                   type="password"
//                   className="form-control"
//                   id="password"
//                   placeholder="Password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                 />
//               </div>
//               <div className="my-3">
//                 <p>
//                   New Here?{" "}
//                   <Link to="/register" className="text-decoration-underline text-info">
//                     Register
//                   </Link>
//                 </p>
//               </div>
//               <div className="text-center">
//                 <button className="my-2 mx-auto btn btn-dark" type="submit">
//                   Login
//                 </button>
//               </div>
//             </form>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;

// import React, { useState, useContext } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { AuthContext } from "../context/AuthContext";

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();
//   const { login, logout, isAuthenticated } = useContext(AuthContext);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const newEntry = { email, password };

//     if (email === "" || password === "") {
//       return window.alert("Please fill out the fields first");
//     }
    
//     // https://yb-restaurant-backend.onrender.com/api/login
//     const url = "https://shopping-site-backend-m1ok.onrender.com/api/login";
//     const params = {
//       method: "post",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(newEntry),
//     };

//     fetch(url, params)
//       .then((res) => {
//         if (!res.ok) {
//           return res.json().then(data => {
//             console.error("Error response from server:", data);
//             setError(data.error || "Login failed");
//             throw new Error(`HTTP status ${res.status}`);
//           });
//         }
//         return res.json();
//       })
//       .then((data) => {
//         if (data.message !== "Login successful") {
//           setError(data.message);
//           return;
//         }
//         login();
//         navigate("/products");
//       })
//       .catch((error) => {
//         console.error("Error during login:", error);
//         setError("An error occurred during login. Please try again.");
//       });
//   };

//   return (
//     <div className="container my-3 py-3">
//       <h1 className="text-center">Login</h1>
//       <hr />
//       <div className="row my-4 h-100">
//         <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
//           {isAuthenticated ? (
//             <div className="text-center">
//               <button className="my-2 mx-auto btn btn-dark" onClick={logout}>
//                 Logout
//               </button>
//             </div>
//           ) : (
//             <form onSubmit={handleSubmit}>
//               <div className="my-3">
//                 <label htmlFor="email">Email address</label>
//                 <input
//                   type="email"
//                   className="form-control"
//                   id="email"
//                   placeholder="name@example.com"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                 />
//               </div>
//               <div className="my-3">
//                 <label htmlFor="password">Password</label>
//                 <input
//                   type="password"
//                   className="form-control"
//                   id="password"
//                   placeholder="Password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                 />
//               </div>
//               <div className="my-3">
//                 <p>
//                   New Here?{" "}
//                   <Link to="/register" className="text-decoration-underline text-info">
//                     Register
//                   </Link>
//                 </p>
//               </div>
//               {error && <div className="alert alert-danger">{error}</div>}
//               <div className="text-center">
//                 <button className="my-2 mx-auto btn btn-dark" type="submit">
//                   Login
//                 </button>
//               </div>
//             </form>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;


// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { Footer, Navbar } from "../components";

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const newEntry = { email, password };
//     console.log([newEntry]);

//     if (email === "" || password === "")
//       return window.alert("Please fill out the fields first");

//     const url = "https://shopping-site-backend-k2t2.onrender.com/api/login";
//     const params = {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(newEntry),
//     };

//     try {
//       const res = await fetch(url, params);
//       const data = await res.json();

//       if (!res.ok) {
//         throw new Error(data.error || 'Login failed');
//       }

//       console.log(data);
//       if (data.message === "Login successful") {
//         navigate("/products");
//       } else {
//         window.alert("Login failed");
//       }
//     } catch (error) {
//       console.error("Error during login:", error);
//       window.alert(error.message);
//     }
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="container my-3 py-3">
//         <h1 className="text-center">Login</h1>
//         <hr />
//         <div className="row my-4 h-100">
//           <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
//             <form onSubmit={handleSubmit}>
//               <div className="my-3">
//                 <label htmlFor="email">Email address</label>
//                 <input
//                   type="email"
//                   className="form-control"
//                   id="email"
//                   placeholder="name@example.com"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                 />
//               </div>
//               <div className="my-3">
//                 <label htmlFor="password">Password</label>
//                 <input
//                   type="password"
//                   className="form-control"
//                   id="password"
//                   placeholder="Password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                 />
//               </div>
//               <div className="my-3">
//                 <p>
//                   New Here?{" "}
//                   <Link to="/register" className="text-decoration-underline text-info">
//                     Register
//                   </Link>
//                 </p>
//               </div>
//               <div className="text-center">
//                 <button className="my-2 mx-auto btn btn-dark" type="submit">
//                   Login
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default Login;

import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Footer, Navbar } from "../components";
import { AuthContext } from "../context/AuthContext";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newEntry = { email, password };

    if (email === "" || password === "")
      return window.alert("Please fill out the fields first");

    const url = "https://shopping-site-backend-k2t2.onrender.com/api/login";
    const params = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(newEntry),
    };

    try {
      const res = await fetch(url, params);
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || 'Login failed');
      }

      if (data.accessToken) {
        login(data.accessToken);
        navigate("/products");
      } else {
        window.alert("Login failed");
      }
    } catch (error) {
      console.error("Error during login:", error);
      window.alert(error.message);
    }
  };

  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center">Login</h1>
        <hr />
        <div className="row my-4 h-100">
          <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
            <form onSubmit={handleSubmit}>
              <div className="my-3">
                <label htmlFor="email">Email address</label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  placeholder="name@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="my-3">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div className="my-3">
                <p>
                  New Here?{" "}
                  <Link to="/register" className="text-decoration-underline text-info">
                    Register
                  </Link>
                </p>
              </div>
              <div className="text-center">
                <button className="my-2 mx-auto btn btn-dark" type="submit">
                  Login
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Login;

